import { render, staticRenderFns } from "./EntranceTeacherList.vue?vue&type=template&id=3b245362&scoped=true&"
import script from "./EntranceTeacherList.vue?vue&type=script&lang=ts&"
export * from "./EntranceTeacherList.vue?vue&type=script&lang=ts&"
import style0 from "./EntranceTeacherList.vue?vue&type=style&index=0&id=3b245362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b245362",
  null
  
)

export default component.exports